export const environment = {
  production: false,
  apiUrl: 'https://staging-api.zetamkkvakicloud.com/api/',
};
